import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '../../routes';
import ServiceTypeItem from '../01_atoms/ServiceTypeItem';

const ServiceList = ({ serviceTypes, showTitle }) => (
  <div className="service-list">
    <div className="wrapper">
      <div className="row">
        {Object.keys(serviceTypes).map(serviceId => (
          <ServiceTypeItem
            {...serviceTypes[serviceId]}
            key={serviceId}
          />))}
      </div>
      {showTitle && (
        <div className="link_arrow">
          <Link to="/services">
            <a><p>Все услуги</p></a>
          </Link>
        </div>
      )}
    </div>
  </div>
);

ServiceList.propTypes = {
  serviceTypes: PropTypes.shape({}).isRequired,
  showTitle: PropTypes.bool,
};

ServiceList.defaultProps = {
  showTitle: false,
};

export default ServiceList;
